import { Tabs as BaseTabs } from '@base-ui/react/tabs'
import { twMerge } from 'tailwind-merge'
import { TabsList } from './nested/list'
import { Tab } from './nested/tab'
import { TabsPanel } from './nested/panel'
import type { PartProps } from '../../lib/part-props'

interface TabsProps extends PartProps<BaseTabs.Root.Props> {
  className?: string
}

function Tabs({ className, children, ...props }: TabsProps) {
  return (
    <BaseTabs.Root className={twMerge('flex flex-col', className)} {...props}>
      {children}
    </BaseTabs.Root>
  )
}

Tabs.List = TabsList
Tabs.Tab = Tab
Tabs.Panel = TabsPanel

export { Tabs }
